<div style="height: 560px;">
  <form [formGroup]="SettingsForm">
    <div class="col-lg-12 mb-1">
      <div class="row">
        <fieldset>
          <legend>Basic Settings</legend>
        </fieldset>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="row">
        <div class="uv-row">
          <div>
            <span>Name:</span>
          </div>
          <div style="margin-left: 10px;">
            <input type="text" pInputText style="width: 250px;" [formControl]="name" />
          </div>
          <div style="margin-left: 30px;">
            <input type="checkbox" style="margin-top: 10px;" [formControl]="enabled" />
            <span class="uv-checkbox-label">Enabled</span>
          </div>
        </div>
      </div>
    </div>
    @if (name.hasError('required')) {
      <div class="row" style="width: 300px; margin-left: 0px; margin-right: 0px;">
        <div class="alert alert-danger">
          This value is required
        </div>
      </div>
    }
    <div class="mb-4"></div>
    <div class="col-lg-12">
      <div class="row">
        <fieldset>
          <legend>SNMP OID Checks</legend>
        </fieldset>
      </div>
    </div>
    <p-table class="custom-snmp-settings-table" [value]="entries" dataKey="entryGuid"
      [resizableColumns]="true"
      [scrollable]="true" scrollHeight="350px"
      [customSort]="true" (sortFunction)="doCustomSort($event)">

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn pSortableColumn="name">
            Name
            <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pResizableColumn pSortableColumn="oid">
            OID
            <p-sortIcon field="oid"></p-sortIcon>
          </th>
          <th class="uv-table-button-column-2">
            <!-- Action Buttons -->
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData">
          <td>
            <span class="uv-table-value">{{rowData['name']}}</span>
          </td>
          <td>
            <span class="uv-table-value">{{rowData['oid']}}</span>
          </td>
          <td class="uv-table-button-column-2">
            <button type="button" class="btn btn-primary uv-first-table-button" (click)="editEntry(rowData)"
              title="Edit the settings for this OID">
              <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn btn-danger uv-table-button" (click)="deleteEntry(rowData)"
              title="Remove this OID">
              <i class="pi pi-trash"></i>
            </button>
          </td>
        </tr>
      </ng-template>

    </p-table>

    <div style="margin-top: 10px;">
      <button type="button" pButton class="custom-snmp-table-button" (click)="addEntry()" icon="fa fa-plus-square-o" label="Add OID"></button>
    </div>

    <custom-snmp-entry [(visible)]="displayEntryEditor" [target]="targetEntry" [isCreate]="isCreate"
    (onSave)="onEditSave()" (onCancel)="onEditCancel()"></custom-snmp-entry>
  </form>
</div>
